import { forwardRef } from 'react';
import { cn } from '@/utils/cn';

interface ILoadingSpinnerProps {
  className?: string;
  isLoading?: boolean;
  borderColor?: string;
  borderTopColor?: string;
  loadingBorderTopColor?: string;
}
const Spinner = forwardRef<HTMLDivElement, ILoadingSpinnerProps>(
  (
    {
      className,
      isLoading = false,
      borderColor = 'border-gray-200',
      borderTopColor = 'border-t-[#0C8DBF]',
      loadingBorderTopColor = 'border-t-black',
    },
    ref
  ) => {
    return (
      <div
        ref={ref}
        className={cn(
          'animate-spin flex-shrink-0 rounded-full h-4 w-4 border-[3px]',
          borderColor,
          isLoading ? loadingBorderTopColor : borderTopColor,
          className
        )}
      ></div>
    );
  }
);

Spinner.displayName = 'Spinner';

export default Spinner;
